import React from "react";
import { useLocation } from "react-router";

const UseRedirectToHttps = () => {
  let location = useLocation();
  // React.useEffect(() => {

  //     if (window.location.protocol!=="https:") {
  //         window.location.replace("https://www.lauramassageyoga.com"+location.pathname);
  //     }
  // })
};

export default UseRedirectToHttps;
